import { memo } from 'react';

import { OnboardingIntroSkyClouds } from '~/components/v2/components/workspace/onboarding-intro/sky/OnboardingIntroSkyClouds';
import { OnboardingIntroSkyWash } from '~/components/v2/components/workspace/onboarding-intro/sky/OnboardingIntroSkyWash';

/** Shared sky layer for the animated onboarding flow — mount once so clouds do not reset between steps. */
export const WorkspaceAnimatedOnboardingSky = memo(() => (
  <>
    <OnboardingIntroSkyWash />
    <OnboardingIntroSkyClouds playEnterAnimation={false} />
  </>
));

WorkspaceAnimatedOnboardingSky.displayName = 'WorkspaceAnimatedOnboardingSky';
